import ReactGA from "react-ga";

import TopBar from "../../components/TopBar";
import ContactForm from "../../components/ContactForm";
import CoreValues from "./coreValues";

import CareersMainImg from "../../assets/images/webp/careers/careersMainImg.webp";

import "./index.scss";

const Careers = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);

  return (
    <div className="careers">
      <TopBar
        heading="Lets work together"
        description="At Omni-Active® Fitness, we’re reimagining both the client and the trainer experience. That means being bold in our decisions and building for something bigger. For us, that means having access to everything you need to be successful, all in one place. Training is what we know and what we do best, but the landscape is ever changing and we pride ourselves in staying ahead of the curve.
        That’s why people want to join us: because our solutions are always for the greater good of both the trainer and the client. The scope of this work means Omni-Active® will be challenging - and will sometimes require creative solutions. We need people who can build others up WHILE building for themselves. We are Omni-Active® Fitness. Are you?"
      />
      <div className="main-image">
        <img className="careers-img" src={CareersMainImg} alt="" />
      </div>
      <CoreValues />
      <ContactForm title="Join the Team" resume={true} />
    </div>
  );
};
export default Careers;
